import CommonFilterBoxField from "./CommonFilterBoxField";
import { useProductStore } from 'src/hooks/product';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { useProductFilterStore } from 'src/hooks/productFilter';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const TopSearchTable = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ category_filter_applied_status, productListWithFacet }, { }, { }, { }] = useProductStore();
    const [load, setLoad] = useState(false);
    const [{ filterList, filterBoxSelection, filterBoxExpanded }, { }, { apply_product_filter, clear_product_filter, apply_product_setting }, { }] = useProductFilterStore();
    const [selectedFilter, setSelectedFilter] = useState('');
    const [searchParams] = useSearchParams();

    const LoadFilterBox = (boxSelectorName) => {
        if (filterBoxSelection[boxSelectorName.slug]) {
            return <CommonFilterBoxField {...boxSelectorName} onFacetsChange={async (filterVal) => {
                filterVal && setSelectedFilter(filterVal)
            }} />
        }
        return '';
    }

    const getAppliedFilterStatusByValue = (value) => {
        let slug = 'flagFacets';
        if (filterList[slug] && filterList[slug]?.s?.length) {
            let decision = false;
            filterList[slug].s.map((v, i) => {
                if (v.value === value) {
                    decision = {
                        v, i
                    };
                }
            });
            return decision;
        }
        return false;
    };

    const isFacets = productListWithFacet?.flagFacets?.flagFacets?.length > 0 ? "filterbox w220" : ""

    useEffect(() => {
        if (isFacets !== '' && load === false) {
            setLoad(true)
        }
    }, [isFacets])

    // pn: Analytics
    useEffect(() => {
        if (selectedFilter && filterList && filterList[selectedFilter?.key]?.s?.length > 0) {
            setSelectedFilter('')
            filterAppliedEvent();
        }
    }, [productListWithFacet])

    const filterAppliedEvent = () => {
        localStorage.setItem("adobeEventType", "searchFilterEvent");
        let makeFilterArr = filterList;
        let filterSlugArr = Object.keys(filterList);
        let filterArrName = [];
        filterSlugArr.forEach((sData) => {
            let newArr = makeFilterArr[sData]?.s;
            newArr.forEach((data, key) => {
                filterArrName.push(data?.value);
            });
        });
        let filterDetails = {
            searchTerm: searchParams.get("search") || '',
            appliedFilterArr: filterArrName?.join(),
            appliedFltCount: filterArrName.length,
            searchCount: productListWithFacet?.productCount,
        };
        if (Object.keys(filterDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ filterDetails });
        }
    }
    
    return (
        <>
            <div className="search-page-tab">
                {/* Nav tabs */}
                {/* Tab panes */}
                <div className="tab-content mb-0">
                    {(__check(['PRODUCT_LISTING_API_CALL']).status || isFacets == '') &&
                        <div className="plp-filter-loader">
                            <div className={`loader-wrapper loader-wrapper-fixed ${(!load) ? ' loader-opacity' : ''}`}>
                                <div className="loading-icon clearfix ">
                                    <div className="ball1"></div>
                                    <div className="ball2"></div>
                                    <div className="ball3"></div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="tab-pane active" id="tab1">
                        <div className="search-filter-wrapper">
                            <div className="container-fluid maxw100">
                                <div className="bs5 row g-20 position-relative search-filter-wrapper-inner">
                                    <div className="col-auto mb-3">
                                        <div className={filterBoxExpanded ? `${isFacets} expanded` : isFacets}>
                                            <div className={load ? "filterbox-body" : "filterbox-body d-none"}>
                                                {productListWithFacet?.flagFacets?.flagFacets?.length > 0 &&
                                                    productListWithFacet.flagFacets.flagFacets.map((v, i) => (
                                                        <div className="form-check" key={i}>
                                                            <input type="checkbox"
                                                                checked={getAppliedFilterStatusByValue(v.main_label)}
                                                                onChange={() => {
                                                                    let d = getAppliedFilterStatusByValue(v.main_label);
                                                                    if (!d) {
                                                                        setSelectedFilter({ key: 'flagFacets', value: v.value });
                                                                        apply_product_filter({
                                                                            key: 'flagFacets',
                                                                            main_label: 'Only Show',
                                                                            value: v.main_label,
                                                                            hidden_payload: {
                                                                                key: v.key,
                                                                                value: v.value
                                                                            },
                                                                        })
                                                                    } else {
                                                                        clear_product_filter({
                                                                            key: 'flagFacets',
                                                                            selectionIndex: d.i,
                                                                        })
                                                                    }
                                                                }}
                                                                disabled={v.count < 1}
                                                                className="form-check-input"
                                                                id={v.main_label} name={v.slug} />
                                                            <label disabled={v.count < 1} className="form-check-label"
                                                                htmlFor={v.main_label}>{v.main_label}<span
                                                                    className="filter-count"> ({v.count})</span></label>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {productListWithFacet && productListWithFacet?.searchFacets && Object.entries(productListWithFacet?.searchFacets).length > 0 &&
                                        Object.entries(productListWithFacet?.searchFacets).map((v, i) => (
                                            <React.Fragment key={i}>
                                                {v[1] && v[1][v[1].slug].length > 0 &&
                                                    <React.Fragment key={i}>

                                                        {LoadFilterBox(v[1])}
                                                    </React.Fragment>
                                                }
                                            </React.Fragment>
                                        ))
                                    }
                                    <div className="col-auto mb-3">
                                        <div
                                            className={category_filter_applied_status === false ? 'filterbox d-none' : (filterBoxExpanded ? 'filterbox add-search-filter expanded' : 'filterbox add-search-filter')}>
                                            <button
                                                style={{
                                                    color: '#ffffff !important'
                                                }}
                                                className="white-bg bs5 btn btn-primary"
                                                onClick={() => {
                                                    props.openFilterBoxSettings()
                                                }}
                                            >Add Filters
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className={filterBoxExpanded ? 'filter-expander expanded' : 'filter-expander'}
                                    onClick={() => {
                                        apply_product_setting({
                                            key: 'filter_box_expanded',
                                            value: !filterBoxExpanded,
                                        });
                                    }}

                                    id="adv_fltrs_sec_hdr"><span id="breadCrumb"
                                        className="fa fa-angle-double-down" />
                                    <span className="fa fa-angle-double-up" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {filterBoxExpanded}
                </div>
            </div>
        </>
    );
}

export default TopSearchTable;